<div class="order-form">
  <button class="btn btn-link p-0 border-0 my-auto" mat-icon-button (click)="onReorderModal(code, totalItems)">
    <mat-icon
      matBadge="+"
      matBadgeSize="small"
      matTooltip="{{ 'buttonTooltip.orderHistory.reorderButton' | cxTranslate }}"
      [matTooltipPosition]="'below'"
      matTooltipClass="icon-tooltip"
      aria-label="displays a tooltip in bottom"
      class="material-icons-sharp light restore-cart mat-icon"
      [matTooltipDisabled]="deviceDetectorService.isMobile() || deviceDetectorService.isTablet()"
      >shopping_cart</mat-icon
    >
  </button>
</div>
